import moment from 'moment';

import {
  GET_BIKE,
  GET_BIKE_PRICES,
  CLEAR_BIKE,
  POST_CREATE_ORDER,
  GET_ORDER,
  POST_ACCEPT_ORDER,
  POST_DECLINE_ORDER,
  POST_CREATE_STRIPE_SETUP_INTENT,
  POST_TRANSACTION,
  GET_TRANSACTION,
  DATA_ORDER_SET_COUNT,
  DATA_ORDER_INIT_ORDER,
  DATA_ORDER_UPDATE_DETAILS,
  DATA_ORDER_UPDATE_DETAILS_VALIDATION
} from '../constants';

import {
  orderBikeSelector,
  bikeOrderDetailsSelector
} from '../selectors';

import {
  createValidator
} from 'utils/validate';

import {
  defaultGetByIdAction,
  defaultCreateAction,
  defaultClearAction
} from 'utils/redux';

import {
  extractSearchParams,
  getDefaultBookingDate,
  getDefaultDropDate
} from 'utils';

export const loadBike = defaultGetByIdAction(GET_BIKE, 'bikes/');

export const loadBikePrices = defaultGetByIdAction(GET_BIKE_PRICES, 'bikes/');

export const clearBike = defaultClearAction(CLEAR_BIKE);

export const clearBikeIfDifferent = (id) => (dispatch, getState) => {
  const bike = orderBikeSelector(getState());

  if (bike && bike.id !== +id) {
    dispatch(clearBike());
  }
};

export const initOrderParams = (query) => {
  const {
    beginDateTime,
    endDateTime,
    count,
    extras,
    ...params
  } = extractSearchParams(query);

  const period = {
    beginDateTime: moment(beginDateTime || getDefaultBookingDate()).toISOString(),
    endDateTime: moment(endDateTime || getDefaultDropDate()).toISOString()
  };

  return {
    type: DATA_ORDER_INIT_ORDER,
    payload: {
      count: count || 1,
      period,
      extras: extras || [],
      params
    }
  };
};

export const createOrder = defaultCreateAction(POST_CREATE_ORDER, 'orders/');
export const loadOrder = defaultGetByIdAction(GET_ORDER, 'orders/');

export const acceptOrder = (orderUid) => ({
  type: POST_ACCEPT_ORDER,
  meta: {
    method: 'POST',
    endpoint: `company/orders/${orderUid}/accept/`
  }
});

export const declineOrder = (orderUid) => ({
  type: POST_DECLINE_ORDER,
  meta: {
    method: 'POST',
    endpoint: `company/orders/${orderUid}/decline/`
  }
});

export const createStripeSetupIntent = defaultCreateAction(
  POST_CREATE_STRIPE_SETUP_INTENT,
  'transactions/create_stripe_setup_intent/'
);
export const createTransaction = defaultCreateAction(POST_TRANSACTION, 'transactions/');
export const loadTransaction = defaultGetByIdAction(GET_TRANSACTION, 'transactions/');

export const setOrderCount = (count) => ({
  type: DATA_ORDER_SET_COUNT,
  payload: {
    count
  }
});

export const updateOrderDetails = (data) => ({
  type: DATA_ORDER_UPDATE_DETAILS,
  payload: {
    data
  }
});

const message = 'error';
const orderValidator = createValidator({
  name: {
    minlength: { data: 2, message }
  },
  email: {
    email: { message }
  },
  emailConfirm: {
    required: { message },
    confirm: { data: 'email', message }
  },
  phone: {
    digitsAndSpaces: { message }
  }
}, {
  digitsAndSpaces: value => /^\+?\d+$/.test(value.replace(/ /g, ''))
});

export const validateOrderDetails = () => (dispatch, getState) => {
  const order = bikeOrderDetailsSelector(getState());
  const errors = orderValidator(order);

  dispatch({
    type: DATA_ORDER_UPDATE_DETAILS_VALIDATION,
    payload: {
      errors
    }
  });

  return errors;
};



// WEBPACK FOOTER //
// ./src/actions/order.js